import type { ReactNode } from 'react';
import React from 'react';

import { ButtonBase, darken, Tooltip } from '@/shared/ui';

export const DrawerButton = ({
  icon,
  disabled,
  variant = 'primary',
  title,
  ...props
}: {
  variant?: 'primary' | 'secondary';
  icon: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  title: string;
}) => {
  return (
    <Tooltip title={title}>
      <span style={{ display: 'inline-flex', height: '100%' }}>
        <ButtonBase
          aria-label={title}
          disabled={disabled}
          sx={theme => ({
            px: 2,
            height: '100%',
            backgroundColor: variant === 'primary' ? 'gx.highlight' : 'gx.tileDark',
            transition: 'background-color 0.13s ease',
            '&.Mui-disabled': {
              backgroundColor: 'gx.textDisabled',
              opacity: 1,
              color: 'gx.neutral'
            },
            '&:hover': {
              backgroundColor: darken(
                variant === 'primary' ? theme.palette.primary.dark : theme.palette.gx.tileDark,
                0.15
              )
            }
          })}
          title={title}
          {...props}
        >
          {icon}
        </ButtonBase>
      </span>
    </Tooltip>
  );
};
